import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import DownloadService from '@/utils/download'
import downloadUtil from '@/utils/downloadUtil'

const state = {
  message: {
    content: '',
    type: ''
  },
  detailList: []
}

const actions = {

  async getInitData ({ dispatch, state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    let type = 'success'
    const response = await ApiManager.request('AnalyzeDetail').analyzeDetailList()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setDetailList', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
    return response.data.data
  },
  /**
   * ダウンロードを実行する
   */
  async download ({ state, commit }, slug) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    const response = await DownloadService.downloadAnalyzeDetail(slug)
    commit('setDetailFile', { data: response, name: slug })
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  setDetailList (state, data) {
    state.detailList = data
  },
  setDetailFile (state, data) {
    downloadUtil(data.data, data.name)
    this.dispatch('loading/loadingPageMinus')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
